import React from "react";

export const Loading = () => {
    return (
        <div className="component__app-state loading">
            <div className="container">
                <div className="row">
                    <div className="col">Loading...</div>
                </div>
            </div>
        </div>
    );
};

export const Error = ({ message }) => {
    return (
        <div className="component__app-state error">
            <div className="container">
                <div className="row">
                    <div className="col">Error: {message}</div>
                </div>
            </div>
        </div>
    );
};
